var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 48,
    viewBox: "0 0 88 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6087 35.0129H8.19069V47.9492H15.0337V42.834L19.1211 46.8251L23.2081 42.834V47.9492H30.0512V35.0129H23.6332L19.1211 39.4191L14.6087 35.0129ZM45.5468 43.0635H41.5791L43.563 40.0703L45.5468 43.0635ZM47.1992 35.0129H39.9255L31.3037 47.9492H38.3652L39.3231 46.5024H47.8016L48.7607 47.9492H55.8219L47.1992 35.0129ZM43.5488 0.949219C19.5241 0.949219 0.0488281 19.9663 0.0488281 43.4253C0.0488281 44.9536 0.131385 46.4631 0.29251 47.9492H4.84758C4.66774 46.4658 4.57505 44.956 4.57505 43.4253C4.57505 22.4072 22.0241 5.3692 43.5488 5.3692C65.0736 5.3692 82.5223 22.4072 82.5223 43.4253C82.5223 44.956 82.4296 46.4658 82.2498 47.9492H86.8048C86.9663 46.4631 87.0488 44.9536 87.0488 43.4253C87.0488 19.9663 67.5736 0.949219 43.5488 0.949219ZM63.8125 35.0129H57.0284V47.9492H63.8702V42.1127L71.9458 47.9492H78.7833V35.0129H71.9405V40.9013L63.8125 35.0129Z",
    fill: "#303C49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManLogo);
export default __webpack_public_path__ + "static/media/MAN Logo.6a310813632a24a38c5df6586cf1935f.svg";
export { ForwardRef as ReactComponent };